export default __webpack_public_path__ + "static/media/ms-neon.a2329217.png";